import React from 'react';
import { useSelector } from 'react-redux';
import { deviceTypes } from '../../../enums/deviceTypes';
import PageHeaderBar from '../pageHeaderBar/PageHeaderBar';
import classes from './Page.module.css';

const Page = ({ title, icon, image, onBack, children, className, pageClassName, headerEndContent }) => {

    const { deviceType } = useSelector(state => state.responsive);

    if (deviceType !== deviceTypes.mobile) {
        return <>
            <div className={`${classes.Page} ${pageClassName || ''} ${className || ''}`}>
                <>
                    {headerEndContent}
                    {children}
                </>
            </div>
        </>
    }

    return (
        <div className={`${classes.Page} ${pageClassName || ''}`}>
            <PageHeaderBar title={title} icon={icon} image={image} onBack={onBack} className={classes.Header} endContent={headerEndContent} />
            <div className={classes.Content}>
                {children}
            </div>
        </div>
    );
};

export default Page;
